import gsap from "gsap";
var TransitionEffect = /** @class */ (function () {
    function TransitionEffect() {
        this.isOpened = false;
        this.numPoints = 2;
        this.delayPointsMax = 0;
        this.delayPerPath = 0;
        this.duration = 0.9;
        this.pointsDelay = [];
        this.allPoints = [];
        this.ease = "Power2.easeInOut";
        this.screen = document.querySelector(".transition-screen");
        this.overlay = document.querySelector(".shape-overlays");
        this.paths = document.querySelectorAll(".shape-overlays__path");
        this.numPaths = this.paths.length;
        var that = this;
        this.tl = gsap.timeline({ onUpdate: function () {
                that.render();
            } });
        for (var i = 0; i < this.numPaths; i++) {
            this.points = [];
            this.allPoints.push(this.points);
            for (var j = 0; j < this.numPoints; j++) {
                this.points.push(100);
            }
        }
        // this.overlay.addEventListener("click", () => {
        //     that.toggle();
        // });
    }
    TransitionEffect.prototype.isOpen = function () {
        this.isOpened = true;
    };
    TransitionEffect.prototype.isClose = function () {
        this.isOpened = false;
    };
    TransitionEffect.prototype.toggle = function () {
        if (this.tl.isActive())
            return false;
        this.screen.classList.add("active");
        this.isOpened = !this.isOpened;
        this.tl.progress(0).clear();
        for (var i = 0; i < this.numPoints; i++) {
            this.pointsDelay[i] = Math.random() * this.delayPointsMax;
        }
        for (var i = 0; i < this.numPaths; i++) {
            this.points = this.allPoints[i];
            var pathDelay = this.delayPerPath * (this.isOpened ? i : (this.numPaths - i - 1));
            for (var j = 0; j < this.numPoints; j++) {
                var config = {
                    ease: this.ease,
                    duration: this.duration
                };
                config[j] = 0;
                var delay = this.pointsDelay[j];
                this.tl.to(this.points, config, delay + pathDelay);
            }
        }
        return this.tl;
    };
    TransitionEffect.prototype.removeScreen = function () {
        if (!this.isOpened) {
            this.screen.classList.remove("active");
        }
    };
    TransitionEffect.prototype.render = function () {
        for (var i = 0; i < this.numPaths; i++) {
            var path = this.paths[i];
            this.points = this.allPoints[i];
            var d = "";
            d += this.isOpened ? "M 0 0 V ".concat(this.points[0], " C") : "M 0 ".concat(this.points[0], " C");
            for (var j = 0; j < this.numPoints - 1; j++) {
                var p = (j + 1) / (this.numPoints - 1) * 100;
                var cp = p - (1 / (this.numPoints - 1) * 100) / 2;
                d += " ".concat(cp, " ").concat(this.points[j], " ").concat(cp, " ").concat(this.points[j + 1], " ").concat(p, " ").concat(this.points[j + 1]);
            }
            d += this.isOpened ? " V 100 H 0" : " V 0 H 0";
            path.setAttribute("d", d);
        }
    };
    return TransitionEffect;
}());
export default TransitionEffect;
;
